export const prevSearchParamsHelper = (newParams, prev) => {
  const merged = new URLSearchParams(prev);
  Object.entries(newParams).forEach(([key, value]) => {
    value == null ? merged.delete(key) : merged.set(key, value);
  });
  return merged;
};
